import {
  mockThreadDetails,
  mockThreadsList,
  ThreadListItem,
  ThreadResponse,
} from "pages/Support/Threads/mockThreads";

export const getThreads = (): Promise<ThreadListItem[]> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(mockThreadsList);
    }, 100);
  });
};

export const getThreadById = async (
  id: number
): Promise<ThreadResponse | undefined> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const meta = mockThreadsList.find((item) => item.id === id);
      if (!meta) return resolve(undefined);

      const details = mockThreadDetails.find((item) => item.id === id);
      if (!details) return resolve(undefined);

      resolve({
        meta,
        details,
      });
    }, 100);
  });
};
